import { TEST_STAND_COOKIE_NAME } from 'utils/constants/app';

import { configureAndInitSentry, ConfiguredSentryResult } from '@hh.ru/sentry-js';

import Cookies from 'bloko/common/Cookies';

const DSN = 'https://3bb013a367c04511ae2166f005c2b9e8@sentry.hh.ru/130140';

const CONFIG = {
    ignorePaths: {
        regexps: [],
    },
    ignoreErrors: {
        strings: [],
        regexps: ['^Недостаточно памяти$'],
    },
};

const isStand = Cookies.get(TEST_STAND_COOKIE_NAME) === 'true';

export const isLoggingEnabled = !isStand;

export const initSentry = (): ConfiguredSentryResult | undefined =>
    configureAndInitSentry({
        sentryLoggingEnabled: isLoggingEnabled,
        sentryJsConfig: JSON.stringify(CONFIG),
        sentryDSN: DSN,
        buildVersion: String(process.env.DefinePluginReleaseVersion),
        getUser: () => ({
            id: Cookies.get('hhuid') ?? undefined,
            userType: '',
        }),
        getExtraData: () => ({}),
        publicBuildPath: '/static',
    });
